"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = void 0;
var Logger_1 = require("./Logger");
function createLogger(options) {
    return 'custom' in options ? options.custom : new Logger_1.Logger(options);
}
exports.createLogger = createLogger;
//# sourceMappingURL=CustomLogger.js.map